import { Tag as AntTag } from 'antd';
import React from 'react';
/*  
 * ​AntDesign's "Tag" component is being overriden and wrapped in a custom component here. 
 *
 * ​When calling "CustomTag" from somewhere in the code, instead of calling antdesign's "Tag", you're calling this component. 
 ​*/

interface TagProps {
  prefixCls?: string;
  className?: string;
  color?: string;
  closable?: boolean;
  closeIcon?: React.ReactNode;
  visible?: boolean;
  onClose?: (e: React.MouseEvent<HTMLElement>) => void;
  style?: React.CSSProperties;
  icon?: React.ReactNode;
  _id: string;
  name: string;
}

export const CustomTag: React.VFC<
  TagProps & React.HTMLAttributes<HTMLDivElement>
> = (props) => {
  return (
    <AntTag
      {...props}
      className={props.className || 'ant-tag-processing'}
      key={props._id}
    >
      #{props.name}
    </AntTag>
  );
};
